// GTM dataLayer - add_to_cart
document.documentElement.addEventListener('variant:add', function(event) {
  var items = event.detail && event.detail.items ? event.detail.items : [];
  items.forEach(function(item) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: Shopify.currency.active,
        value: item.price / 100,
        items: [{
          item_id: String(item.product_id),
          item_name: item.product_title || item.title,
          price: item.price / 100,
          quantity: item.quantity
        }]
      }
    });
  });
});


// Block auto-select until a size is chosen; theme handles the button after that.
customElements.whenDefined('variant-picker').then(function() {
  var VariantPicker = customElements.get('variant-picker');
  if (!VariantPicker || VariantPicker.prototype.__sizeDeselect) return;

  VariantPicker.prototype.__sizeDeselect = true;
  var selectVariant = VariantPicker.prototype.selectVariant;

  VariantPicker.prototype.selectVariant = function(id) {
    if (this.hasAttribute('deselect-size')) {
      var sizeSelectors = this.querySelectorAll('[data-size-option] [data-option-selector]');
      if (sizeSelectors.length) {
        var allSizesPicked = Array.prototype.every.call(sizeSelectors, function(sizeSelector) {
          return sizeSelector.querySelector('input[type="radio"]:checked')
            || (sizeSelector.querySelector('input[type="hidden"][name^="option"]') || {}).value;
        });
        if (!allSizesPicked) {
          if (this.masterSelector) {
            this.masterSelector.value = '';
          }
          return;
        }
      }
    }
    return selectVariant.apply(this, arguments);
  };
});


document.addEventListener('variant:change', function(event) {
  var form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  var picker = document.querySelector('variant-picker[deselect-size][form="' + form.getAttribute('id') + '"]');
  if (!picker) return;

  var button = form.querySelector('buy-buttons button[type="submit"]');
  if (!button) return;

  var sizeSelectors = picker.querySelectorAll('[data-size-option] [data-option-selector]');
  var waitingForSize = sizeSelectors.length && !Array.prototype.every.call(sizeSelectors, function(sizeSelector) {
    return sizeSelector.querySelector('input[type="radio"]:checked')
      || (sizeSelector.querySelector('input[type="hidden"][name^="option"]') || {}).value;
  });

  if (waitingForSize) {
    button.classList.add('button--select-size', 'button--outline', 'button--subdued');
  } else {
    button.classList.remove('button--select-size', 'button--outline', 'button--subdued');
  }
});


window.addEventListener('DOMContentLoaded', function() {
  const sticky = document.getElementById('product--sticky');
  const mobileSticky = document.getElementById('product--sticky__mobile');
  if (sticky && mobileSticky) {
    const mainSection = document.querySelector('.shopify-section--main-product buy-buttons');
    if (mainSection) {
      if (mainSection.getBoundingClientRect().bottom > 0 && mainSection.getBoundingClientRect().top < window.innerHeight) {
        mobileSticky.classList.remove('active')
      } else {
        mobileSticky.classList.add('active')
      }
      if (mainSection.getBoundingClientRect().bottom > 0) {
        sticky.classList.remove('active');
      } else {
        sticky.classList.add('active');
      }

      window.addEventListener('scroll', function() {
        if (mainSection.getBoundingClientRect().bottom > 0 && mainSection.getBoundingClientRect().top < window.innerHeight) {
          mobileSticky.classList.remove('active')
        } else {
          mobileSticky.classList.add('active')
        }
        if (mainSection.getBoundingClientRect().bottom > 0) {
          sticky.classList.remove('active');
        } else {
          sticky.classList.add('active');
        }
      });
    }
  }

  document.querySelector('.header__primary-nav button[aria-controls="sidebar-menu"]').addEventListener('click', function(){
    var element = document.documentElement;
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  })

  const mobileMenuBtn = document.querySelector('x-header button[aria-controls="sidebar-menu"]');
  
  mobileMenuBtn.addEventListener('click', function(){
    document.querySelector('#sidebar-menu .header-sidebar__linklist li button[aria-expanded="true"]').click();
  }, { once: true });
});